<template>
  <div class="app-container">
    <div class="handleExport-zy">投诉列表</div>
    <!-- 搜索栏 -->
    <el-form :model="queryParams" :inline="true" v-show="showSearch">
      <el-form-item label="">
        <el-input @keyup.enter.native="handleQuery" v-model="queryParams.query.projectNameORUserName" style="width: 200px" placeholder="项目名称/投诉人" clearable />
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="queryParams.query.processStatus" placeholder="全部状态">
          <el-option label="处理中" value="0"></el-option>
          <el-option label="已处理" value="1"></el-option>
          <el-option label="已退回" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="queryParams.query.amountLevel" placeholder="全部金额等级">
          <el-option label="100万以上" value="1"></el-option>
          <el-option label="100万以下" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button type="primary" icon="el-icon-fake custom-icon icon-policy-download" @click="handleExportCase" :loading="exportCaseLoading">
          导出投诉</el-button>
      </el-form-item>
    </el-form>
    <!-- 操作按钮 -->
    <el-row :gutter="10" class="mb15 operation-buttons">
      <el-col :span="1.5">
        <div  v-hasPerm="'log:exception:import'" class="batch-insert-wrapper">
          <my-batch-insert type="exception" @handleUpdateData="getList"></my-batch-insert>
        </div>
      </el-col>
<!--      <el-col :span="1.5">-->
<!--        <el-button type="warning" @click="exportList">-->
<!--&lt;!&ndash;          <el-icon><Download></Download></el-icon>&ndash;&gt;-->
<!--          导出投诉</el-button-->
<!--        >-->
<!--      </el-col>-->
     
    </el-row>

    <!-- 表格展示 -->
    <div class="table-wrapper">
      <el-table border :data="logList" @selection-change="handleSelectionChange" v-loading="loading" class="data-table">
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <!-- 投诉编号 -->
      <el-table-column prop="complaintCode" label="投诉编号" align="center" width="270"></el-table-column>
      <!-- 项目名称 -->
      <el-table-column prop="projectName" label="项目名称" align="center" width="160" show-overflow-tooltip></el-table-column>
      <!-- 投诉人姓名 -->
      <el-table-column prop="userId" label="投诉人姓名" align="center" width="100" show-overflow-tooltip></el-table-column>
      <!-- 岗位 -->
      <el-table-column prop="position" label="岗位" align="center" width="150" show-overflow-tooltip></el-table-column>
      <!-- 欠薪金额(元) -->
      <el-table-column prop="arrearsAmount" label="欠薪金额(元)" align="center" width="150"></el-table-column>
      <!-- 投诉来源 -->
      <!-- <el-table-column label="投诉来源" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.complaintSource === 0 ? '扫描二维码' : '表格导入' }}
        </template>
      </el-table-column> -->
      <!-- 分派状态 -->
      <el-table-column label="分派状态" align="center" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.assignStatus === 0 ? 'info' : 'success'">
<!--            {{ scope.row.assignStatus === 1 ? '已分派' : '未分派' }}-->
            <template v-if="scope.row.assignStatus === 0">未分派</template>
            <template v-if="scope.row.assignStatus === 1">一级已分派</template>
            <template v-if="scope.row.assignStatus === 2">二级已分派</template>
          </el-tag>
        </template>
      </el-table-column>
      <!-- 处理状态 -->
      <el-table-column label="处理状态" align="center" width="110">
        <template slot-scope="scope">
          <template v-if="scope.row.validInvalid === 1">
            <el-tag type="danger">
              已标记无效
            </el-tag>
          </template>
          <template v-else>
            <el-tag :type="['warning','success','danger'][scope.row.processStatus] || '处理中'">
              {{  ['处理中','已处理','已退回'][scope.row.processStatus] || '处理中' }}
            </el-tag>
          </template>
        </template>
      </el-table-column>
      <!-- 结案状态 -->
      <el-table-column label="结案状态" align="center" width="110">
        <template slot-scope="scope">
          <el-tag :type="getCaseStatusType(scope.row.caseStatus)">
            {{ getCaseStatusText(scope.row.caseStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- 提交时间 -->
      <el-table-column prop="complaintTime" label="提交时间" align="center" width="180"></el-table-column>
      <!-- 是否上传附件 -->
      <!-- <el-table-column label="是否上传附件" align="center" width="140">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.attachments && scope.row.attachments.length > 0 ? 'success' : 'info'">
                        {{ scope.row.attachments && scope.row.attachments.length > 0 ? '已上传' : '未上传' }}
                    </el-tag>
                </template>
            </el-table-column> -->
      <!-- 操作 -->
      <el-table-column label="操作" align="center" min-width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <template v-if="!scope.row.readonly && scope.row.caseStatus == 0">
          <!-- <template v-if="scope.row.caseStatus == 0"> -->
            <!--人社局分派-->
            <el-button type="text" @click="assign(scope.row, 1)" v-if="scope.row.isProcess === 1 && scope.row.assignStatus == 0">分派</el-button>
            <!--二级单位分派  isProcess-是否可以分派   assignStatus-分派状态 0-未分派 1-已分拍 processStatus-处理状态- 0  -->
            <el-button type="text" @click="assign(scope.row, 2)" v-if="scope.row.isProcess === 2 && scope.row.assignStatus == 1 && scope.row.processStatus != 1">分派</el-button>
            <!--二级单位处置 分派前可操作-->
            <el-button type="text" style="color: #F56C6C" @click="Attachment(scope.row.id)" v-if="scope.row.isProcess == 2 && scope.row.assignStatus != 2 && scope.row.processStatus != 1"> 处置 </el-button>
            <!--处置方案一 处理状态不为已处理 则一直显示-->
            <el-button type="text" style="color: #F56C6C" @click="Attachment(scope.row.id)" v-if="scope.row.isProcess == 0 && scope.row.assignStatus == 2 && scope.row.processStatus != 1"> 处置 </el-button>
            
            <!--处置方案二 任何处理状态都可处置-->
            <!--<el-button type="text" style="color: #F56C6C" @click="Attachment(scope.row.complaintId)" v-if="(scope.row.isProcess === 0 || 2) && scope.row.assignStatus == 2 && scope.row.caseStatus == 0"> 处置 </el-button>-->
            <!--二级单位、项目方退回-->
            <el-button type="text" style="color: #F56C6C" @click="goBack(scope.row, scope.row.assignStatus)" v-if="(((scope.row.isProcess == 0) && scope.row.assignStatus == 2) || (scope.row.isProcess == 2 && scope.row.assignStatus == 1)) && scope.row.processStatus != 1"> 退回 </el-button>
            <!--人社局退回-->
            <el-button type="text" style="color: #F56C6C" @click="goBack(scope.row, scope.row.assignStatus)" v-if="scope.row.isProcess === 1 && scope.row.assignStatus == 0"> 退回 </el-button>
            <el-button type="text" style="color: #67C23A" @click="goAudit(scope.row)" v-if="((scope.row.isProcess === 2 && scope.row.assignStatus === 2)||(scope.row.isProcess === 1)) && scope.row.assignStatus != 0 && scope.row.processStatus == 1 && scope.row.caseStatus == 0 && scope.row.needAudit === 1"> 审核 </el-button>
            <el-button type="text" style="color: #67C23A" @click="goEnd(scope.row.id)" v-if="((scope.row.isProcess === 2 && scope.row.assignType === 2) || scope.row.isProcess === 1) && scope.row.processStatus == 1 && scope.row.caseStatus == 0 && scope.row.needAudit === 0"> 结案 </el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(scope.row.id)" v-if="scope.row.isProcess != 0 && scope.row.caseStatus == 0"> 标记无效投诉 </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    </div>
   
    <!-- 分页 -->
    <div class="pagination-wrapper">
      <pagination v-if="count > 0" :total="count" :page.sync="queryParams.current" :limit.sync="queryParams.size" @pagination="getList"/>
    </div>
    <!-- 查看详情对话框 -->
    <el-dialog title="查看详情" :visible.sync="open" width="50%" append-to-body>
      <div class="watch-detail">
        <div class="detail-info">
          <div class="title" style="font-size: 16px;font-weight: 700;color: #301330;margin-bottom: 16px">基本信息</div>
          <el-form :model="exceptionLog" label-width="120px" v-if="1">
            <el-form-item label="投诉编号：">{{ exceptionLog.complaintCode }}</el-form-item>
            <el-form-item label="项目名称：">{{ exceptionLog.projectName }}</el-form-item>
            <el-form-item label="投诉人姓名：">{{ exceptionLog.userId }}</el-form-item>
            <el-form-item label="岗位：">{{ exceptionLog.position }}</el-form-item>
            <el-form-item label="欠薪金额：">{{ exceptionLog.arrearsAmount }}</el-form-item>
            <el-form-item label="投诉来源：">{{ exceptionLog.complaintSource === 0 ? '线上' : '线下' }}</el-form-item>
            <el-form-item label="分派状态：">
              {{ exceptionLog.assignStatus === 0 ? '未分派' :
                exceptionLog.assignStatus === 1 ? '一级已分派' :
                    '二级已分派' }}
            </el-form-item>
            <el-form-item label="处理状态：">{{  ['处理中','已处理','已退回'][exceptionLog.processStatus] || '处理中' }}</el-form-item>
            <el-form-item label="结案状态：">{{ getCaseStatusText(exceptionLog.caseStatus) }}</el-form-item>
            <el-form-item label="提交时间：">{{ exceptionLog.createTime }}</el-form-item>
            <el-form-item label="附件：">{{ exceptionLog.complaintCode }}</el-form-item>
          </el-form>
          <el-form v-if="0" :model="exceptionLog" label-width="120px">
            <el-form-item label="投诉编号：">{{ exceptionLog.complaintCode }}</el-form-item>
            <el-form-item label="项目名称：">{{ exceptionLog.projectName }}</el-form-item>
            <el-form-item label="投诉人姓名：">{{ exceptionLog.userId }}</el-form-item>
            <el-form-item label="岗位：">{{ exceptionLog.position }}</el-form-item>
            <el-form-item label="欠薪金额(元)：">{{ exceptionLog.arrearsAmount }}</el-form-item>
            <el-form-item label="投诉来源：">{{ exceptionLog.complaintSource === 0 ? '线上' : '线下' }}</el-form-item>
            <el-form-item label="分派状态：">
              {{ exceptionLog.assignStatus === 0 ? '未分派' :
                exceptionLog.assignStatus === 1 ? '一级已分派' :
                '二级已分派' }}
            </el-form-item>
            <el-form-item label="处理状态：">{{ exceptionLog.processStatus === 1 ? '已处理' : '处理中' }}</el-form-item>
            <el-form-item label="结案状态：">{{ getCaseStatusText(exceptionLog.caseStatus) }}</el-form-item>
            <el-form-item label="提交时间：">{{ exceptionLog.createTime }}</el-form-item>
            <el-form-item label="附件：" v-if="exceptionLog.attachments">
              <!-- <el-image src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/pdf.png" alt="" /> -->
              <div class="fujian" v-for="(value, index) in exceptionLog.attachments" :key="value.fileId || value.fileUrl || index">
                <div class="boxs" v-if="value.fileType == 'image/png' || value.fileType == 'image/jpeg' || value.fileType == 'image/jpg'">
                  <!-- <img :src="value.fileUrl" alt="" /> -->
                  <el-image style="width: 100px; height: 100px" :src="imageUrlprefix + value.fileUrl" :preview-src-list="[imageUrlprefix + value.fileUrl]" fit="cover" />
                  <span>{{ value.fileName }}</span>
                </div>
                <div class="boxs" v-else-if="value.fileType === 2">
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/pdf.png" alt="" />
                  <span>{{ value.fileName }}</span>
                </div>
                <div class="boxs" v-else-if="value.fileType === 3">
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/word.png" alt="" />
                  <span>{{ value.fileName }}</span>
                </div>
                <div class="boxs" v-else>
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/default-file.png" alt="" />
                  <span>{{ value.fileName }}</span>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="detail-log">
          <div class="title" style="font-size: 16px;font-weight: 700;color: #301330;margin-bottom: 16px;padding-left: 40px">处置信息</div>
          <el-scrollbar class="detail-log-box">
            <el-timeline>
              <el-timeline-item type="primary" :hollow="true" timestamp="2018/4/3" placement="top">
                <el-card>
                  <template slot="header">
                    <b>投诉处置</b>
                  </template>
                  <p>十全十美处置了投诉信息</p>
                </el-card>
              </el-timeline-item>
              <el-timeline-item type="primary" :hollow="true" timestamp="2018/4/3" placement="top">
                <el-card>
                  <template slot="header">
                    <b>投诉分派</b>
                  </template>
                  <p>街镇分派了投诉信息</p>
                </el-card>
              </el-timeline-item>
              <el-timeline-item type="primary" :hollow="true" timestamp="2018/4/3" placement="top">
                <el-card>
                  <template slot="header">
                    <b>投诉退回</b>
                  </template>
                  <p>十全十美退回了投诉信息</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-scrollbar>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 分派对话框 -->
    <el-dialog title="投诉分派" :visible.sync="assignDialogVisible" width="50%" append-to-body>
      <!-- 分派表单 -->
      <el-form :model="assignParams" label-width="100px" style="margin-top: 20px">
        <el-form-item label="分派至" required>
          <el-select v-model="assignParams.region" placeholder="请选择分派目标" style="width: 100%">
            <el-option v-for="(item, index) in DispatchList" :key="item.id || index" :label="item.deptName" :value="item.id"></el-option>
          </el-select>
<!--          <el-input v-if="isDispatchDept" :value="DispatchList.find((item)=>item.deptId === assignParams.region)?.name || ''" disabled />-->
<!--          <el-input v-else :value="DispatchList.find((item)=>item.deptId === assignParams.region)?.name || ''" disabled />-->
        </el-form-item>
        <el-form-item label="分派说明">
          <el-input type="textarea" v-model="assignParams.description" :rows="4" placeholder="请输入分派说明"></el-input>
        </el-form-item>
      </el-form>

      <!-- 分派提示 -->
      <!-- <div class="info-text">
        <el-alert title="分派提示" type="info" :closable="false" description="系统检测到您选择的投诉中，1条项目金额≥100万，应分派至区建管委+行业主管部门； 1条项目金额<100万，应分派至街镇/园区。" show-icon> </el-alert>
      </div> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAssign">确认分派</el-button>
      </span>
    </el-dialog>
    <exception-detail-modal ref="exceptionDetailModalRef" />
    <audit-modal ref="AuditModalRef" @handleUpdateData="handleUpdateData"></audit-modal>
  </div>
</template>

<script>
import { getComplaintList, dispatchInfo, getDispatchList, invalidComplaint, exportComplaintInfo } from '@/api/unpaidWages/complaint'
import { downLoadFile } from '@/utils/downLoad'
import {messageConfirm, notifyFail, notifySuccess} from '@/utils/modal'
import exceptionDetailModal from '../components/exceptionDetailModal/index.vue'
import AuditModal from "@/components/myComponents/MyTimeLine/components/AuditModal.vue";
import myBatchInsert from "@/components/myComponents/MyBatchInsert/index.vue";

export default {
  name: 'Exception',
  components: {
    exceptionDetailModal,
    AuditModal,
    myBatchInsert
  },
  data() {
    return {
      count: 0,
      open: false,
      assignDialogVisible: false,
      showSearch: true,
      loading: false,
      queryParams: {
        current: 1,
        size: 10,
        query: {
          projectNameORUserName: '',
          processStatus: '',
          amountLevel: '',
        },
      },
      logIdList: [],
      logList: [],
      exceptionLog: {},
      assignParams: {
        region: '',
        description: '',
      },
      currentAssignId: '',
      DispatchList: [],
      isDispatchDept: true, // 分派给部门/负责人  true-部门
      assignType: 1, // 分派标识  1- 1级分派 2-2级分派
      exportCaseLoading: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /** 列表/导出共用的 query（下拉为字符串，接口需数字时转换） */
    buildComplaintListQuery() {
      const q = { ...this.queryParams.query }
      if (q.processStatus !== '' && q.processStatus != null) {
        q.processStatus = parseInt(String(q.processStatus), 10)
      }
      if (q.amountLevel !== '' && q.amountLevel != null) {
        q.amountLevel = parseInt(String(q.amountLevel), 10)
      }
      return q
    },
    getComplaintListParams() {
      return {
        pageNum: this.queryParams.current,
        pageSize: this.queryParams.size,
        query: this.buildComplaintListQuery(),
      }
    },
    // 获取投诉列表数据
    getList() {
      this.loading = true

      getComplaintList(this.getComplaintListParams())
        .then((response) => {
          // 根据实际响应结构解析数据

          if (response && response.code === 200 && response.data) {
            this.logList = response.data.rows || []
            this.count = response.data.total || 0
          } else {
            // 兼容旧的数据结构
            if (response.data && response.data.flag) {
              this.logList = response.data.data?.recordList || []
              this.count = response.data.data?.count || 0
            } else {
              this.logList = []
              this.count = 0
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 获取结案状态文本
    getCaseStatusText(status) {
      switch (status) {
        case 0:
          return '处理中'
        case 1:
          return '已结案'
        case 2:
          return '已退回'
        default:
          return '未知'
      }
    },


    // 获取结案状态标签类型
    getCaseStatusType(status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'success'
        case 2:
          return 'danger'
        default:
          return 'info'
      }
    },

    // 查询按钮点击事件
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },

    // 重置按钮点击事件
    handleReset() {
      this.queryParams = {
        current: 1,
        size: 10,
        query: {
          projectNameORUserName: '',
          processStatus: '',
          amountLevel: '',
        },
      }
      this.getList()
    },

    // 导入
    importList() {
      console.log("导入");
    },
    // 导出
    handleExportCase() {
      this.exportCaseLoading = true
      exportComplaintInfo(this.buildComplaintListQuery()).then(res => {
          if (res) {
            downLoadFile(res,'投诉列表',new Date().getTime(),'xls')
          }
      }).finally(() => {
          this.exportCaseLoading = false
      })
      
    },

    handleView(log) {
      this.$refs.exceptionDetailModalRef.handleOpen(log);
      // this.exceptionLog = log
      // this.open = true
    },

    // 打开分派对话框
    async assign(row, assignTypeNum = 1) {
      this.assignType = assignTypeNum;
      this.isDispatchDept = true;
      this.currentAssignId = row.id;

      const deptTypeList = assignTypeNum === 1 ? [2, 3, 4, 5] : [6];
      const res =  await getDispatchList({projectId:row.projectId, deptTypeList});
      this.DispatchList = res.data
      this.assignParams = {
        region: '',
        description: '',
      }
      
      // 设置默认值：使用 isDefault 字段来判断（后端返回的标记）
      this.DispatchList.forEach((item) => {
        if (item.isDefault == 1) {
          this.assignParams = {
            region: item.id,
            description: '',
          }
        }
      })
      
      this.assignDialogVisible = true
    },

    // 确认分派
    async confirmAssign() {
      if (!this.assignParams.region) {
        notifyFail('请选择分派目标')
        return
      }

      try {
        await messageConfirm('确认分派?')

        // 构建分派请求数据
        const dispatchData = {
          assignStatus: this.assignType,
          id: this.currentAssignId,
          assignTargetId: this.assignParams.region, // 使用选择的区域作为目标ID
          assignExplain: this.assignParams.description || '', // 使用说明，如果没有则为空字符串
        }

        // 调用分派API
        const response = await dispatchInfo(dispatchData)
        

        if (response.code == 200) {
          notifySuccess('分派成功')
          this.assignDialogVisible = false
          this.getList() // 刷新列表
        } else {
          notifyFail(response.msg || '分派失败')
        }
      } catch (error) {
        console.error('分派失败:', error)
        notifyFail('分派失败')
      }
    },

    handleSelectionChange(selection) {
      this.logIdList = selection.map((item) => item.complaintId)
    },

    handleDelete(id) {
      messageConfirm('确认标记为无效投诉?')
        .then(() => {
          // 这里调用删除API
          invalidComplaint({id}).then(() => {
            notifySuccess('标记成功')
            this.getList()
          })
        })
        .catch(() => {})
    },

    /** 去处置*/
    Attachment(id) {
      console.log(id,'当前列表的id')
      this.$store.dispatch('attachment/saveCurrentId', id)
      this.$router.push({
        path: '/laborRelations/unpaidWages/complaint/operation',
      })
    },

    //去退回
    goBack(row, assignStatus) {
      console.log(row,'当前列表的row')
      this.$store.dispatch('attachment/saveCurrentId', row.id)
      this.$store.dispatch('attachment/saveAssignOptions', {
        assignStatus: assignStatus,
        assignTargetId: row.assignTargetId,
        secondAssignTargetId: row.secondAssignTargetId
      });
      this.$router.push({
        path: '/laborRelations/unpaidWages/complaint/visit',
      })
    },

    // 去审核
    goAudit(row) {
      if (this.$refs.AuditModalRef) {
        this.$refs.AuditModalRef.handleOpen(row.recordId, row.complaintId);
      }
    },

    // 审核完成回调 更新数据
    handleUpdateData() {
      this.getList();
    },

    //去结案
    goEnd(id) {
      console.log(id, '结案的id')
      this.$store.dispatch('attachment/saveCurrentId', id)
      this.$router.push({
        path: '/laborRelations/unpaidWages/complaint/auditing',
      })
    }
  }
}
</script>

<style scoped>
.handleExport-zy {
  margin-bottom: 30px;
}

.info-text {
  margin-bottom: 20px;
}
.fujian {
  overflow: hidden;
  height: 80px;
  width: 80px;
  color: #aaa;
  line-height: 50px;
  font-size: 14px;
  text-align: center;
}

.fujian .boxs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.fujian .boxs > * {
  margin-bottom: 12px;
}
.fujian .boxs > *:last-child {
  margin-bottom: 0;
}
.fujian .boxs img {
  width: 48px;
  height: 48px;
  border: #aaa 2px dotted;
  border-radius: 5px;
}

.fujian .boxs span {
  width: 100%;
  height: 20px;
  font-size: 12px;
  text-align: center;
  line-height: 14px;
  color: #aaa;
}
::v-deep .is-light {
  background: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

::v-deep .el-alert__description {
  color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}

.watch-detail {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.detail-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.detail-log {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}

/* 操作按钮区域样式 */
.operation-buttons {
  margin-bottom: 15px;
}

/* 批量导入组件包装器，添加间距 */
.batch-insert-wrapper {
  display: inline-block;
}

.batch-insert-wrapper ::v-deep .el-dropdown {
  margin-right: 10px;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item {
  padding: 8px 0;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item:not(:last-child) {
  margin-bottom: 8px;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item .el-button {
  width: 100%;
  margin: 0;
}

/* 表格包装器 - 确保滚动条在底部 */
.table-wrapper {
  width: 100%;
  position: relative;
}

/* 表格样式 - 设置最小高度和间距 */
.data-table {
  margin-top: 0;
  width: 100%;
}

/* 确保表格滚动条在底部显示 */
.table-wrapper ::v-deep .el-table {
  overflow-x: auto;
}

.table-wrapper ::v-deep .el-table__body-wrapper {
  overflow-x: auto;
  overflow-y: auto;
}

/* 确保固定列的滚动条也在底部 */
.table-wrapper ::v-deep .el-table__fixed,
.table-wrapper ::v-deep .el-table__fixed-right {
  bottom: 0;
  height: 100% !important;
}

.table-wrapper ::v-deep .el-table__fixed-body-wrapper {
  bottom: 0;
}

/* 确保表格容器有足够的高度 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索栏样式 */
.el-form {
  margin-bottom: 20px;
}

/* 分页样式 */
.pagination-wrapper {
  margin-top: 20px;
}
</style>
